export const VENDOR_LIST = "VENDOR_LIST";